import { gql } from '@apollo/client';
import _ from 'lodash';
import React from 'react';
import Badge from '../../components/Badge';
import type { UserBadge_UserFragment } from '../../graphql/generated/graphqlTypes';

const USER_FRAGMENT = gql`
  fragment UserBadge_user on User {
    deactivatedAt
    importedFrom
    type
  }
`;

interface UserBadgeProps {
  user: UserBadge_UserFragment;
  inline?: boolean;
}

export const userBadgeColors = {
  ADMIN: 'blue',
  DEACTIVATED: 'gray',
  GUEST: 'yellow',
  IMPORTED: 'gray',
  INVITED: 'gray',
  BOT: 'pink',
} as const;

const UserBadge = ({
  user: { deactivatedAt, type, importedFrom },
  inline,
}: UserBadgeProps) => {
  if (importedFrom) {
    return (
      <Badge color={userBadgeColors.IMPORTED} inline={inline}>
        Imported
      </Badge>
    );
  }
  if (deactivatedAt) {
    return (
      <Badge color={userBadgeColors.DEACTIVATED} inline={inline}>
        Deactivated
      </Badge>
    );
  }
  if (type && type !== 'USER') {
    return (
      <Badge color={userBadgeColors[type]} inline={inline}>
        {_.capitalize(type)}
      </Badge>
    );
  }

  return null;
};

UserBadge.fragments = {
  user: USER_FRAGMENT,
};

export default UserBadge;
